export { default as COUNTRY_SELECT_OPTIONS } from './countrySelectOptions';
export { default as CANADA_COUNTRY_OPTION } from './countryCanadaOnly';
export { default as US_COUNTRY_OPTION } from './countryUSOnly';
export { default as CANADA_US_COUNTRY_OPTION } from './countryUSCanadaOnly';
export { default as EUROPE_COUNTRY_OPTION } from './countryEuropeOptions';
export { default as ENGLAND_COUNTRY_OPTION } from './countryENOnly';
export { default as AUSTRALIA_COUNTRY_OPTION } from './countryAUOnly';
export { default as DENMARK_COUNTRY_OPTION } from './countryDKOnly';
export { default as SWEDEN_COUNTRY_OPTION } from './countrySEOnly';
export { default as NORWAY_COUNTRY_OPTION } from './countryNOOnly';
export { default as POLAND_COUNTRY_OPTION } from './countrPLOnly';
export { default as CURRENCY_SELECT_OPTIONS } from './currencySelectOptions';
export { default as TRANSFER_TYPE_SELECT_OPTIONS } from './transferFundSelectOptions';
export { default as CURRENCY_LIST_OPTIONS } from './currencyListOptions';
export { default as NUMERIC_MONTH_OPTIONS } from './numericMonthSelectionOptions';
export { default as TRANSACTION_TYPE_SELECT_OPTIONS } from './transactionTypeSelectOptions';
export { default as US_ACCOUNT_TRANSACTION_TYPE_SELECT_OPTIONS } from './usAccountTransactionTypeSelectOptions';
export { default as TRANSACTION_STATUS_SELECT_OPTIONS } from './transactionStatusSelectOptions';
export { default as US_CURRENCY_ONLY } from './usCurrencyOnly';
export { default as CA_CURRENCY_ONLY } from './caCurrencyOnly';
export { default as BUSINESS_TYPES_OPTIONS } from './businessTypeOptions';
export { default as PLATFORM_USAGE_OPTIONS } from './platformUsageOptions';
export { default as TERM_OPTIONS } from './termOptions';
export { default as ACCOUNT_SELECTION_METHOD_OPTIONS } from './accountSelectionMethodOptions';
export { default as LANGUAGE_SELECTION_OPTIONS } from './languageSelectionOptions';
export { default as PAYMENT_METHOD_OPTIONS } from './paymentMethodOptions';
export { default as ACCOUNT_TYPE_OPTIONS } from './accountTypeOptions';
export { default as ACCOUNT_CONNECTION_OPTIONS } from './accountConnectionOptions';
export { default as ETRANSFER_CONNECTION_OPTIONS } from './etransferConnectionOptions';
export { default as FREQUENCY_OPTIONS } from './frequencyOptions';
export { default as DATA_AGGREGATOR_OPTIONS } from './dataAggregatorOptions';
export { default as CANADIAN_PROVENCES } from './canadianProvinces';
export { default as US_STATES } from './usProvinces';
export { default as COUNTRIES } from './countries';
export { default as SUBSCRIPTION_DATE_FORMAT_SELECT_OPTIONS } from './subscriptionDateFormatSelectOptions';
export { default as SUBSCRIPTION_SCHEDULE_TYPE_OPTIONS } from './subscriptionScheduleTypeOptions';
export { default as SCHEDULED_TRANSFER_FREQUNCY_OPTIONS } from './ScheduledTransferFrequencyOptions';
export { default as PARTNER_USER_ROLE_OPTIONS } from './partnerUserRolesOptions';
export { default as ACCOUNT_INTENDED_TRANSACTION_TYPES } from './accountIntendedTransactionTypes';
export { default as AVAILABLE_TIMEZONES } from './availableTimezones';

export { default as ACCOUNTING_SYSTEM_OPTIONS } from './accountingSystemOptions';

// shared dashbaord
export const LS_USER_ACCOUNT_ID = 'vPAccountId';
export const LS_USER_API_KEY = 'vPAccountKey';
export const LS_USER_API_SIG = 'vPAccountSignature';
export const LS_USER_NAME = 'vPAccountUsername';
export const LS_USER_JWT = 'vPJWT';
export const LS_REMEMBER_MFA = 'vp__rememberMfa';
export const LS_MFA_HASH = 'vp__MfaHash';

// partner dashbaord
export const LS_USER_PERMISSIONS = 'vpPAPermissions';
export const LS_USER_PARTNER_TYPE = 'vpPAType';
export const LS_USER_LOGIN_NAME = 'vpPAccountLoginName';
export const LS_SIGNER_CREATION = 'vpPSignerCreation';
export const LS_ACCOUNT_TOKEN = 'vpPAccountToken';
export const LS_PARTNER_ACCOUNTS_RESPONSE = 'vpPPartnerAccountsResponse';
export const LS_PARTNER_TRANSACTIONS_RESPONSE = 'vpPPartnerTransactionsResponse';
export const LS_USER_API_KEY_PARTNER = 'vPAccountKeyPartner';
export const LS_USER_API_SIG_PARTNER = 'vPAccountSignaturePartner';

// IQ11 & Paylink
export const LS_IQ11_TOKEN = 'vPIQ11Token';
export const LS_IQ11_TOKEN_INFO = 'vPIQ11TokenInfo';
export const LS_IQ11_FOR_ONBOARDING = 'vPIQ11ForOnboarding';
export const LS_IQ11_IS_BROWSER = 'vPIQ11IsBrowser';
export const LS_BANK_TYPE = 'vPBankType';
export const LS_ACCOUNT_TYPE = 'vPAccountType';
export const LS_BANK_INFO = 'vPBankInfo';
export const LS_MAIN_BANK_INFO = 'vPMainBankInfo';
export const LS_SUB_BANK = 'vPSubBank';
export const LS_BANK_ACCOUNT_RAIL = 'VP__BankAccountRail';
export const LS_PAYLINK_TOKEN = 'vPPaylinkToken';
export const LS_ACCOUNT_VERIFICATION_TOKEN = 'vPAccountVerificationToken';
export const LS_PAD_INFO = 'vPPadInfo';
export const LS_PAYMENT_METHOD = 'vPPaymentMethod';
export const LS_ACCESS_TOKEN = 'vPAccessToken';
export const LS_PROCESSOR = 'vPProcessor';
export const LS_ACCESS_TOKEN_EXTRA_INFO = 'vPAccessTokenExtraInfo';
export const LS_USER_DOMAIN = 'vpPAccountDomain';

// account dashboard
export const LS_USER_LOGIN_USER_NAME = 'vPLoginUserName';
export const LS_USER_LOGIN_SUCCESS = 'vPUserLoginSuccess';
export const LS_USER_CLIENT_ACCOUNT_ID = 'vPAccountId';
export const LS_USER_ACCOUNT_NAME = 'vPAccountName';
export const LS_USER_FIREBASE_TOKEN = 'vPFirebaseToken';
export const LS_USER_COUNTRY = 'vPCountry';
export const LS_USER_GCM_ENABLED = 'vPGCMEnabled';
export const LS_USER_EFT_COLLECT_ENABLED = 'vPEFTCollectEnabled';
export const LS_USER_EFT_SEND_ENABLED = 'vPEFTSendEnabled';
export const LS_USER_ACH_FUND_ENABLED = 'vPACHFundEnabled';
export const LS_USER_ACH_WITHDRAW_ENABLED = 'vPACHWithdrawEnabled';
export const LS_USER_USD_EFT_COLLECT_ENABLED = 'vPUSDEFTCollectEnabled';
export const LS_USER_USD_EFT_SEND_ENABLED = 'vPUSDEFTSendEnabled';
export const LS_USER_RTR_WITHDRAW_ENABLED = 'vPRTRWithdrawEnabled';
export const LS_USER_RTP_WITHDRAW_ENABLED = 'vPRTPWithdrawEnabled';
export const LS_USER_FEDWIRE_WITHDRAW_ENABLED = 'vPFedwireWithdrawEnabled';
export const LS_USER_VISA_DIRECT_ENABLED = 'vPVisaDirectEnabled';
export const LS_USER_INTERAC_MONEY_REQUEST_ENABLED = 'vPInteracMoneyRequestEnabled';
export const LS_USER_INBOUND_ETRANSFER_ENABLED = 'vPInboundEtransferEnabled';
export const LS_USER_INTERAC_BULK_PAYOUT_ENABLED = 'vPInteracBulkPayoutEnabled';
export const LS_USER_PORTALVIEWONLY = 'vPPortalViewOnly';
export const LS_USER_KYC_LIGHT_ENABLED = 'vpKYCLightEnabled';
export const LS_USER_MONEY_REQUEST_GENERATE_URL_ENABLED = 'vPMoneyRequestGenerateUrlEnabled';
export const LS_USER_SUB_ACCOUNT_PERMISSIONS = 'vPSubAccountPermissions';
export const LS_USER_CLIENT_ACCOUNT_ENABLED = 'vPClientAccountsEnabled';
export const LS_USER_AUTO_BALANCE_TRANSFER_ENABLED = 'vPAutoBalanceTransferEnabled';
export const LS_USER_TRANSACTION_LABEL_OVERRIDER_ENABLED = 'vPTransactionLabelOverrideEnabled';
export const LS_USER_IQ11_STANDARD_ENABLED = 'vPIQ11StandardEnabled';
export const LS_USER_IQ11_BOOST_ENABLED = 'vPIQ11BoostEnabled';
export const LS_USER_IQ11_PLUS_ENABLED = 'vPIQ11PlusEnabled';
export const LS_USER_IQ11_ADVANTAGE_ENABLED = 'vPIQ11AdvantageEnabled';
export const LS_USER_TRANSATION_SERVICE_DEFAULT = 'vPTransactionServiceDefault';
export const LS_USER_PAYLINK_ENABLED = 'vPPayLinkEnabled';
export const LS_USER_CUSTOM_FLINKS_CREDENTIALS_SET = 'vPCustomFlinksCredentialsSet';
export const LS_USER_CUSTOM_PLAID_CREDENTIALS_SET = 'vPCustomPlaidCredentialsSet';
export const LS_USER_CUSTOMER_INVERITE_CREDENTIALS_SET = 'vPCustomInveriteCredentialsSet';
export const LS_USER_ENABLE_PAYLINK_DECLINE = 'vPEnablePaylinkDecline';
export const LS_USER_CREDITCARD_ENABLED = 'vPCreditCardEnabled';
export const LS_USER_DIGITAL_WALLETS_ENABLED = 'vPDigitalWalletsEnabled';
export const LS_USER_PAYPAL_WITHDRAW_ENABLED = 'VP__ClientDashboard__Permissions__paypalWithdrawEnabled';
export const LS_USER_VENMO_WITHDRAW_ENABLED = 'VP__ClientDashboard__Permissions__venmoWithdrawEnabled';
export const LS_USER_GOOGLE_PAY_ENABLED = 'vPGooglePayEnabled';
export const LS_USER_USER_MANAGEMENT_ENABLED = 'vPUserManagementEnabled';
export const LS_USER_ACCOUNTING_SOFTWARE_INTERGRATION_ENABLED = 'vPAccountingSoftwareIntegrationEnabled';
export const LS_USER_ACCOUNTING_SYSTEM_INTERGRATION_ENABLED = 'vPAccountingSystemIntegrationEnabled';
export const LS_USER_ACCOUNT_TRANSFER_ENABLED = 'vPAccountTransferEnabled';
export const LS_USER_PUSH_TO_CARD_ENABLED = 'vPPushToCardEnabled';
export const LS_USER_REAL_TIME_MONEY_REQUEST_ENABLED = 'vPRealTimeMoneyRequestEnabled';
export const LS_USER_CUSTOM_GLOBAL_PAY_SHARED_SECRET = 'vPCustomGlobalPaySharedSecret';
export const LS_USER_ACCOUNT_TYPE = 'vPAccountType';
export const LS_USER_CLIENT_DOMAIN = 'vPDomain';
export const LS_USER_MFA_ENABLED = 'vPMFAEnabled';
export const LS_USER_BRANDING_EMAIL_ENABLED = 'vPBrandingEmailEnabled';
export const LS_USER_BRANDING_ELINX_ENABLED = 'vPBrandingElinxEnabled';
export const LS_USER_BRANDING_PORTAL_ENABLED = 'vPBrandingPortalEnabled';
export const LS_USER_BRANDING_ONBORDING_ENABLED = 'vPBrandingOnboardingEnabled';
export const LS_USER_INTERAC_BASIC_VERIFICATION_ENABLED = 'vPInteracBasicVerificationEnabled';
export const LS_USER_INTERAC_ENHANCED_VERIFICATION_ENABLED = 'vPInteracEnhancedVerificationEnabled';
export const LS_USER_TRANSACTION_APPROVAL_WORKFLOW_ENABLED = 'vPTransactionApprovalWorkflowEnabled';
export const LS_USER_MICRO_DEPOSIT_BANK_ACCOUNT_VERIFICATION_ENABLED = 'vPMicroDepositBankAccountVerificationEnabled';
export const LS_USER_CARD_BASIC_VERIFICATION_ENABLED = 'vPCardBasicVerificationEnabled';
export const LS_USER_CARD_ENHANCED_VERIFICATION_ENABLED = 'vPCardEnhancedVerificationEnabled';
export const LS_USER_FILE_CONVERSION_ENABLED = 'vPFileConversionEnabled';
export const LS_USER_FILE_SUBMISSION_ENABLED = 'vPFileSubmissionEnabled';
export const LS_EMAIL_DOMAIN_ENABLED = 'vPEmailDomainEnabled';
export const LS_CHAT_SUPPORT_ENABLED = 'vPChatSupportEnabled';
export const LS_INTERAC_VERIFICATION_ENABLED = 'vPInteracVerificationEnabled';
export const LS_BILL_PAY_ENABLED = 'vPBillPayEnabled';
export const LS_ACCOUNT_AND_BILLING_ENABLED = 'vPAccountAndBillingEnabled';
export const LS_FUND_MY_ACCOUNT_ENABLED = 'vPFundMyAccountEnabled';
export const LS_WITHDRAW_MY_ACCOUNT_ENABLED = 'vPWithdrawMyAccountEnabled';
export const LS_BANK_ACCOUNT_TRANSFER_ENABLED = 'vPBankAccountTransferEnabled';
export const LS_OPERATIONAL_ACCOUNTS_ENABLED = 'vPOperationalAccountsEnabled';
export const LS_PARTNER_BILLS_ACCOUNT = 'vPPartnerBillsAccount';
export const LS_PAYMENTS_ENABLED = 'vPPaymentsEnabled';
export const LS_COLLECTIONS_ENABLED = 'vPCollectionsEnabled';
export const LS_SHOW_SUB_ACCOUNT_ORG_CHART = 'vPShowSubAccountOrgChart';
export const LS_PUSH_TO_CARD_PROCESSOR = 'vPPushToCardProcessor';
export const LS_CREDIT_CARD_PROCESSOR = 'vPCreditCardProcessor';
export const LS_ACH_FUNDING_PROCESSOR = 'vPACHFundingProcessor';
export const LS_ACH_WITHDRAW_PROCESSOR = 'vPACHWithdrawProcessor';
export const LS_INTERAC_MONEY_REQUEST_PROCESSOR = 'vPInteracMoneyRequestProcessor';
export const LS_INTERAC_BULK_PAYOUT_PROCESSOR = 'vPInteracBulkPayoutProcessor';
export const LS_FEDWIRE_PROCESSOR = 'vPFedwireProcessor';
export const LS_RTP_PROCESSOR = 'vPRTPProcessor';
export const LS_FEDNOW_PROCESSOR = 'vPFednowProcessor';
export const LS_USER_PARENT_ACCOUNT_ID = 'vPParentAccountId';
export const LS_USER_PARENT_ACCOUNT_NAME = 'vPParentAccountName';
export const LS_USER_SUB_ACCOUNT_TYPE = 'vPSubAccountType';
export const LS_INTEREST_ACCOUNT_ENABLED = 'vPInterestAccountEnabled';
export const LS_SUPPORT_TICKET_ENABLED = 'vpSupportTicketEnabled';
export const LS_USER_PASSWORD_RESET_REQUIRED = 'vPPasswordResetRequired';
export const LS_USER_CLIENT_PERMISSIONS = 'vPUserPermissions';
export const LS_USER_ADDITIONAL_ACCOUNTS = 'vPAdditionalAccounts';
export const LS_PAYLINK = 'vPPaylink';
export const LS_CURRENCY = 'vPCurrency';
export const LS_IS_INSIDE_SALES = 'vpPIsInsideSales';
export const LS_USER_AUTOREFRESH = 'vPAutoRefresh';
export const LS_USER_BANNER = 'vPBannerUser';
export const LS_USER_NO_OPERATIONAL_DEFAULT_MODAL = 'vPNoOperationalDefaultModal';
export const LS_USER_ROLE = 'vpPUserRole';
export const LS_DASHBOARD_TOKEN = 'dashboardToken';
export const LS_DASHBOARD_USERNAME = 'dashboardUsername';

// Onboadring
export const LS_APPLICATION_TOKEN = 'ApplicationToken';
export const LS_ONBOARDING_USER_EMAIL = 'UserEmail';
export const LS_ONBOARDING_USER_NAME = 'UserName';
export const LS_ONBOARDING_USER_ROLE = 'UserRole';
export const LS_ONBOARDING_USER_INFO = 'UserInfo';
export const LS_BEARER_TOKEN = 'BearerToken';
export const LS_LEGAL_AGREEMENT = 'LegalAgreement';
export const LS_OTP = 'OTP';
export const LS_VALID_EMAIL = 'ValidEmail';
export const LS_VALID_OTP = 'ValidOtp';
export const LS_APPLICATION_SUBMISSION = 'ApplicationSubmission';
export const LS_APPLICATION_ID = 'ApplicationId';
export const LS_REDIRECT_URL = 'RedirectUrl';
export const LS_APPLICATION_LANGUAGE = 'ApplicationLanguage';
export const LS_MERCHANT_TOKEN = 'MerchantToken';

// Crossborder Iframe
export const LS_CROSSBORDER_TOKEN = 'CrossBorderToken';
export const LS_GLOBAL_SEND_ADMIN_TOKEN = 'GlobalSendAdminToken';
export const LS_CROSSBORDER_GLOBAL_TRANSFER = 'CrossBorderGlobalTransfer';
export const LS_BILL_PAYMENT_TOKEN = 'BillPaymentToken';

//Transaction Approval
export const LS_TRANSACTION_APPROVAL_TOKEN = 'VP__TransactionApproval__token';
export const LS_TRANSACTION_APPROVAL_ACTION = 'VP__TransactionApproval__action';
export const LS_TRANSACTION_APPROVAL_APPROVER_ID = 'VP__TransactionApproval__approverId';

export const LS_DISPUTE_MANAGEMENT_TOKEN = 'DisputeManagement';

export const LS_ADDRESS_VERIFICATION_TOKEN = 'VP__AddressVerification__singleUseToken';

export const CLIENT_ACCOUNT_ID_REGEX = /^[\^A-Za-z0-9\s!@#$%^&*()_+=\-/<>,.{}[\]\\|~:;?]*$/;
// export const CLIENT_ACCOUNT_ID_NO_SPECIAL_CHARS_REGEX = /[^A-Za-z0-9\s]/; // directly from backend; uncomment if needed
